import React, { useState, useEffect, ReactElement } from "react";
import { IFilterValueListItem } from "../../../../backend/interfaces/filters/IFilterValueListItem";
import { SelectOption } from "../FilterOperatorSelect";
import Select from "react-select";
import { useTranslation } from "react-i18next";

interface IArbitraryListProps {
  items: IFilterValueListItem[];
  selectedItems: string[];
  onChange: (selectedItems: IFilterValueListItem[]) => void;
  isMultiselect: boolean;
}

export const ArbitraryList = (props: IArbitraryListProps): ReactElement => {
  const { t } = useTranslation();

  const [selectedIndexes, setSelectedIndexes] = useState([]);

  const arbitraryOptions: SelectOption[] = props.items.map((i) => ({ value: i.value.toString(), label: i.displayName }));


  useEffect(() => {
    const newSelectedItemsIndexes = [];
    const selectedItemsIds = props.selectedItems.map((valueString) => parseInt(valueString));
    const allItemsIds = props.items.map((item) => item.value);
    for (let i = 0; i < allItemsIds.length; i++) {
      if (selectedItemsIds.includes(allItemsIds[i])) {
        newSelectedItemsIndexes.push(i);
      }
    }

    setSelectedIndexes(newSelectedItemsIndexes);
  }, [props.items, props.selectedItems]);

  return ( 
    <Select
      options={arbitraryOptions}
      defaultValue={selectedIndexes.map( (idx) => arbitraryOptions[idx] )}
      value={selectedIndexes.map( (idx) => arbitraryOptions[idx] )}
      isMulti={props.isMultiselect}
      placeholder={`${t("command.select")}...`}
      styles={{ 
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
        control: (base) => ({...base, background: 'white', border: '1px solid #78899a', borderRadius: 0}),
        multiValue: (base) => ({...base, fontSize: "16px"}), //multiValue child has 85% font
        option: provided => ({...provided, color: 'black'}),
      }}
      onChange={(item) => {

        if ( ! props.isMultiselect ) {

          const selectedIndex = arbitraryOptions.findIndex((value: SelectOption) => value.value === (item as SelectOption).value)
          setSelectedIndexes( [selectedIndex] );

          props.onChange( [props.items[selectedIndex]] );

        } else {

          const newSelectedIndexes = (item as SelectOption[]).map((item) => parseInt(item.value));
          setSelectedIndexes(newSelectedIndexes);

          const selectedItems = props.items.filter(item => newSelectedIndexes.includes(item.value)) 
          props.onChange( selectedItems );
        }
      }}
    /> 

  );
};
